"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedSearchCardClickEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class RelatedSearchCardClickEvent extends BaseAvroRecord_1.BaseAvroRecord {
    schema() {
        return RelatedSearchCardClickEvent.schema;
    }
    subject() {
        return RelatedSearchCardClickEvent.subject;
    }
}
exports.RelatedSearchCardClickEvent = RelatedSearchCardClickEvent;
RelatedSearchCardClickEvent.subject = "related-search-card-click-event";
RelatedSearchCardClickEvent.schema = {
    "type": "record",
    "name": "RelatedSearchCardClickEvent",
    "namespace": "storyblocks.search",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "USER_SERVICE",
                                "SUBSCRIPTION_SERVICE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "searchIdentifiers",
            "type": {
                "type": "record",
                "name": "SearchIdentifiers",
                "namespace": "storyblocks.search.records",
                "fields": [
                    {
                        "name": "searchId",
                        "type": "string",
                        "doc": "f.k.a. SSLID"
                    },
                    {
                        "name": "searchPageId",
                        "type": "string",
                        "doc": "f.k.a. SGUID"
                    },
                    {
                        "name": "lastSearchId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "doc": "Previous searchId",
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "searchKeyword",
            "type": "string"
        },
        {
            "name": "availableTerms",
            "type": {
                "type": "array",
                "items": "string"
            }
        },
        {
            "name": "clickedTerm",
            "type": "string"
        },
        {
            "name": "clickedTermPosition",
            "type": "int"
        }
    ]
};
//# sourceMappingURL=RelatedSearchCardClickEvent.js.map